
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { Procedure, ApiGateway } from 'cw-backend';
import { SnackBarService } from 'cw-utils';


@Injectable()
export class ProcedureEditProvider implements Resolve<any> {
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    procedure: Procedure;

    constructor(public gw: ApiGateway, public snackBar: SnackBarService) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getProcedure()]).then(() => {
                sessionStorage.setItem(
                    "navigation",
                    location.pathname.toString()
                );
                resolve();
            }, reject);
        });
    }

    getProcedure(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.routeParams.id === "novo") {
                this.onDataChanged.next(false);
                resolve(false);
            } else {
                this.gw
                    .get("procedure/wAll/" + this.routeParams.id)
                    .subscribe((res: Procedure) => {
                        this.procedure = res;
                        this.onDataChanged.next(this.procedure);
                        resolve(res);
                    }, reject);
            }
        });
    }

    insert(procedure): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post("procedure/", procedure)
                .subscribe((response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                }, reject);
        });
    }

    edit(procedure): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .put("procedure/", procedure)
                .subscribe((response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                }, reject);
        });
    }

    delete(procedure): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .delete("procedure/" + procedure.id)
                .subscribe((response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                }, reject);
        });
    }

    deleteProcedureCode(procedureCodeId:number) {
        return new Promise((resolve, reject) => {
            this.gw.delete(`procedure/procedure-code/${procedureCodeId}`)
            .subscribe({
                next: res =>{
                    console.log(res);
                    this.snackBar.successMessage(res.body.message);
                }
            })
        });
    }

    insertTableStandart(accreditation) {
        return new Promise((resolve, reject) => {
            this.gw.post("procedure/tableStandart/", accreditation).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                },
                error: (err: HttpResponse<any>) => {
                    reject(err);
                },
            });
        });
    }
}
